import { render } from "./ButtonsSlider.vue?vue&type=template&id=5c14ef4c&scoped=true"
import script from "./ButtonsSlider.vue?vue&type=script&lang=js"
export * from "./ButtonsSlider.vue?vue&type=script&lang=js"

import "./ButtonsSlider.vue?vue&type=style&index=0&id=5c14ef4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c14ef4c"]])

export default __exports__